<template>
  <div class="mb-7 text-center">
    <div><IconCheckmarkRound class="mr-2 inline-block w-5 fill-lime pb-1" />Access to 12 hours of learning on a live workshop</div>
    <div><IconCheckmarkRound class="mr-2 inline-block w-5 fill-lime pb-1" />Certificate endorsed by Cypress DX team</div>
    <div><IconCheckmarkRound class="mr-2 inline-block w-5 fill-lime pb-1" />Lifetime access to Discord support channel</div>
    <div><IconCheckmarkRound class="mr-2 inline-block w-5 fill-lime pb-1" />Repository with a real application</div>
    <div><IconCheckmarkRound class="mr-2 inline-block w-5 fill-lime pb-1" />Coding challenges and learning materials</div>
  </div>
</template>
